import {AppHelper} from "@/AppHelper";
import {computed, getCurrentInstance, onMounted, ref, watch} from "vue";
import StyleClassicPreview from "@/preview/ClassicStyle";
import StylePoetPreview from "@/preview/PoetStyle";
import StyleAstronomerPreview from "@/preview/AstronomerStyle";
import StyleAquarellesPreview from "@/preview/AquarellesStyle";
import StyleRomanticPreview from "@/preview/RomanticStyle";
import StyleModernPreview from "@/preview/ModernStyle";
import StylePhotographerPreview from "@/preview/PhotographerStyle";
import StyleExplorerPreview from "@/preview/ExplorerStyle";
import StyleMountainPreview from "@/preview/MountainStyle";

import GlobalCollapseSetting from "./components/GlobalCollapseSetting";
import GlobalProductConfirm from "@/components/GlobalProductConfirm";
import GlobalSectionSetting from "./components/GlobalSectionSetting";
import GlobalAddToCart from "@/components/GlobalAddToCart";
import ParseSpecifications from "@/commons/ParseSpecifications";

export default {
	name: "DesktopEditor",
	components: {
		StyleClassicPreview,
		StylePoetPreview,
		StyleAstronomerPreview,
		StyleAquarellesPreview,
		StyleRomanticPreview,
		StyleModernPreview,
		StylePhotographerPreview,
		StyleExplorerPreview,
		StyleMountainPreview,

		GlobalCollapseSetting,
		GlobalProductConfirm,
		GlobalSectionSetting,
		GlobalAddToCart,
	},

	props: {
        isNonceReady: {
            type: Boolean
        },
    },

	setup() {
		const tabOpen = ref('style');
		
		const collapseStatus = getCurrentInstance().appContext.config.globalProperties.collapse_status;

		const tabCloseEvent = () => {
			tabOpen.value = "";
		}
		const tabOpenEvent = (tabName) => {
			tabOpen.value = tabName
		}

		var LANG = getCurrentInstance().appContext.config.globalProperties.LANG;

		const {
			spec,
			selectedOptions,
			posterStyles,
			posterLayout,
			posterSizes,
			additionSettings,
			loadComponentPreview,
			priceFinal,

			selectStyleMethod,
			selectLayoutMethod,
			selectSizeMethod,
			pickSettingMethod,
			addToCartSubmit,

			showPopup,
			cartContext,
			onClosePopupReviewMethod,
			sendEmailMethod,
			StarMapImage,
			previewDimension,
			getPriceIngredient,
		} = AppHelper('desktop');

		window.nse_app.poster_px = previewDimension;

		const styleWrapperPreview = computed(() => {
			var style = `width:${previewDimension.value.width}px; height:${previewDimension.value.height}px;`
			if (selectedOptions.value.poster_size.scale) {
				style += `transform:scale(${selectedOptions.value.poster_size.scale})`
			}
			return style;
		});

		const backgroundColors = computed(() => {
			var output = [];
			if (!selectedOptions.value.poster_style.has_background) return output;

			if (selectedOptions.value.star_map_color) {
				output.push(Object.assign({}, selectedOptions.value.star_map_color, {
					"name": "background_color"
				}));
			}

			output.push({
				"title": LANG.COLOR_WHITE,
				"value": "#ffffff",
				"name": "background_color"
			});
			return output;
		});
		const tabs = computed(()=>{
			const output = [{
				"title": LANG.STYLE,
				"name": "style"
			}]

			if (selectedOptions.value.poster_style) {
				selectedOptions.value.poster_style.settings.map((setting) => {
					if (setting.name !== "product_detail") {
						output.push({
							"title": setting.title,
							"name": setting.name
						})
					}
				})
			}

			return output;
		})


		const lastTab = computed(()=> {
			return nse_config.product_info.cart_item_key.length > 0 || (Object.keys(collapseStatus.value).length === tabs.value.length)
		})

		const nextStep = () => {
			for (let i = 0; i < tabs.value.length; i++) {
				const element = tabs.value[i];
				if (!collapseStatus.value[element.name]) {
					tabOpen.value = element.name
					return
				}
			}
		};

		const qAUrl = window.nse_config.q_a_url;
		return {
			loadComponentPreview,

			selectedOptions,
			posterStyles,
			posterLayout,
			posterSizes,
			additionSettings,
			priceFinal,

			styleWrapperPreview,
			previewDimension,
			//Methods
			selectStyleMethod,
			selectLayoutMethod,
			selectSizeMethod,
			pickSettingMethod,
			addToCartSubmit,

			backgroundColors,

			tabOpen,
			tabCloseEvent,
			tabOpenEvent,

			lastTab,
			nextStep,

			showPopup,
			cartContext,
			onClosePopupReviewMethod,
			sendEmailMethod,

			qAUrl,
			StarMapImage,
			getPriceIngredient
		}
	}
}
